var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTooltipQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 10C2.25 12.0554 3.06652 14.0267 4.51992 15.4801C5.97333 16.9335 7.94457 17.75 10 17.75C12.0554 17.75 14.0267 16.9335 15.4801 15.4801C16.9335 14.0267 17.75 12.0554 17.75 10C17.75 7.94457 16.9335 5.97333 15.4801 4.51992C14.0267 3.06652 12.0554 2.25 10 2.25C7.94457 2.25 5.97333 3.06652 4.51992 4.51992C3.06652 5.97333 2.25 7.94457 2.25 10Z",
    stroke: "#A8B2C8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 8C8.75 7.30964 9.30964 6.75 10 6.75C10.6904 6.75 11.25 7.30964 11.25 8C11.25 8.47217 10.9885 8.88435 10.5988 9.09765C10.3056 9.25818 9.98452 9.48334 9.72851 9.78185C9.46923 10.0842 9.25 10.4957 9.25 11V11.5C9.25 11.9142 9.58579 12.25 10 12.25C10.4142 12.25 10.75 11.9142 10.75 11.5V11C10.75 10.952 10.768 10.8739 10.8671 10.7584C10.9695 10.639 11.1279 10.5181 11.3191 10.4134C12.1702 9.94752 12.75 9.04201 12.75 8C12.75 6.48122 11.5188 5.25 10 5.25C8.48122 5.25 7.25 6.48122 7.25 8C7.25 8.41421 7.58579 8.75 8 8.75C8.41421 8.75 8.75 8.41421 8.75 8ZM10 15C10.5523 15 11 14.5523 11 14C11 13.4477 10.5523 13 10 13C9.44772 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15Z",
    fill: "#A8B2C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTooltipQuestion);
export default __webpack_public_path__ + "static/media/icon-tooltip-question.3a44601cf1feb03d7065c16361473b45.svg";
export { ForwardRef as ReactComponent };